import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-de047c02")

_pushScopeId("data-v-de047c02")
const _hoisted_1 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_2 = { class: "p-m-2" }
const _hoisted_3 = { class: "dataset-info-span" }
const _hoisted_4 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_5 = { class: "p-m-2" }
const _hoisted_6 = { class: "dataset-info-span" }
const _hoisted_7 = {
  key: 0,
  class: "p-d-flex p-flex-row p-ai-center"
}
const _hoisted_8 = { class: "p-m-2" }
const _hoisted_9 = { class: "dataset-info-span" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      header: _ctx.$t('workspace.federationDefinition.datasetDetail'),
      style: _ctx.worskpaceFederationDatasetDialogDescriptor.dialog.style,
      visible: _ctx.visible,
      modal: true,
      class: "p-fluid kn-dialog--toolbar--primary",
      closable: false
    }, {
      footer: _withId(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withId(() => [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_1, [
            _createVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('common.name')), 1),
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.dataset.name), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('common.label')), 1),
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.dataset.label), 1)
          ]),
          (_ctx.dataset.description)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('common.description')), 1),
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.dataset.description), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["header", "style", "visible"])
  ]))
})